import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import {
  Drawer,
  Box,
  Typography,
  Button,
  DrawerProps,
  SxProps,
} from '@mui/material';
import { useState } from 'react';

type SessionStatType = 'correct' | 'incorrect' | 'skipped' | 'time';

interface ISessionStatCardProps {
  icon: React.ReactNode; // supports string, emoji, or MUI icon
  label: string;
  value: string | number;
  type: SessionStatType;
}
export const SessionStatCard = ({
  icon,
  label,
  value,
  type,
}: ISessionStatCardProps) => {
  const stylesByType = {
    correct: {
      border: '#dcfce7',
      bg: 'linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%)',
      iconColor: '#22c55e',
    },
    incorrect: {
      border: '#fecaca',
      bg: 'linear-gradient(180deg, #fef2f2 0%, #ffffff 100%)',
      iconColor: '#ef4444',
    },
    skipped: {
      border: '#e0e7ff',
      bg: 'linear-gradient(180deg, #eef2ff 0%, #ffffff 100%)',
      iconColor: '#6366f1',
    },
    time: {
      border: '#fef3c7',
      bg: 'linear-gradient(180deg, #fffbeb 0%, #ffffff 100%)',
      iconColor: '#f59e0b',
    },
  };

  const style = stylesByType[type];

  return (
    <Box
      sx={{
        borderRadius: pxToRem(16),
        padding: `${pxToRem(18)} ${pxToRem(12)}`,
        textAlign: 'center',
        border: `1.5px solid ${style.border}`,
        background: style.bg,
      }}
    >
      <Typography
        sx={{
          fontSize: pxToRem(18),
          marginBottom: pxToRem(6),
          color: style.iconColor,
        }}
      >
        {icon}
      </Typography>

      <Box display="flex" flexDirection="column" gap={0.5}>
        <Typography
          sx={{
            fontSize: pxToRem(22),
            fontWeight: 800,
            color: '#1e293b',
          }}
        >
          {value}
        </Typography>

        <Typography
          sx={{
            fontSize: pxToRem(11),
            fontWeight: 600,
            color: '#94a3b8',
            textTransform: 'uppercase',
            letterSpacing: 0.5,
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};
